import classNames from 'classnames';
import { useEffect, useState } from 'react';
import variables from '@/components/organisms/main-navigation/main-navigation.variables';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';
import useIsAtTop from '@/libraries/hooks/use-is-at-top';
import InPageNavigationSearchDetails from '../in-page-navigation-search-details/in-page-navigation-search-details';
import styles from './in-page-navigation-footer.module.scss';

interface InPageNavigationFooterProps extends ModuleWrapperProps {
  /** The anchor link id to scroll to configuration flow module */
  configurationFlowAnchorLinkId?: string;
  /** The total price */
  totalPrice: number;
}

const InPageNavigationFooter = ({
  configurationFlowAnchorLinkId,
  totalPrice,
  ...rest
}: InPageNavigationFooterProps) => {
  const [renderFooter, setRenderFooter] = useState(false);
  const { ctaRefPosition } = usePageDetailsContext();

  const topContentHeight =
    variables.mainNavigationLargeHeight +
    variables.mainNavigationLargeMarginTop;

  const isAtTop = useIsAtTop(topContentHeight);

  useEffect(() => {
    setRenderFooter(
      !isAtTop && ctaRefPosition !== null && ctaRefPosition !== 'inView',
    );
  }, [ctaRefPosition, isAtTop]);

  return (
    <ModuleWrapper
      {...rest}
      className={classNames(styles.component, {
        [styles.isVisible]: renderFooter,
      })}
      padding="none"
    >
      <Container>
        <InPageNavigationSearchDetails
          className={styles.details}
          configurationFlowAnchorLinkId={configurationFlowAnchorLinkId}
          totalPrice={totalPrice}
        />
      </Container>
    </ModuleWrapper>
  );
};

InPageNavigationFooter.displayName = 'InPageNavigationFooter';

export default InPageNavigationFooter;
